import { createContext, useCallback, useContext, useMemo, useState } from "react";
import type { Session } from "@/types";

interface SessionContextValue {
  session:Session|null;
  setSession:(value:Session|null)=>void;
  pendingSharedFile:File|null;
  setPendingSharedFile:(value:File|null)=>void;
  pendingSharedText:string;
  setPendingSharedText:(value:string)=>void;
}
const SessionContext=createContext<SessionContextValue|null>(null);
export function SessionProvider({children}:{children:React.ReactNode}) {
  const [session,setSessionState]=useState<Session|null>(()=>{ try { const raw=sessionStorage.getItem("share-session"); return raw?JSON.parse(raw):null; } catch { return null; } });
  const [pendingSharedFile,setPendingSharedFile]=useState<File|null>(null);
  const [pendingSharedText,setPendingSharedText]=useState("");
  // Stable identity: pairing callbacks depend on it, and a new one per render would re-run their effects.
  const setSession=useCallback((value:Session|null)=>{setSessionState(value);if(value)sessionStorage.setItem("share-session",JSON.stringify(value));else sessionStorage.removeItem("share-session")},[]);
  const value=useMemo(()=>({session,setSession,pendingSharedFile,setPendingSharedFile,pendingSharedText,setPendingSharedText}),[pendingSharedFile,pendingSharedText,session,setSession]);
  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
}
export function useSession(){const value=useContext(SessionContext);if(!value)throw new Error("useSession must be used inside SessionProvider");return value}
